import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";


import { wordlist } from "./words.js";
import { satlist } from "./sat.js";

("use strict");

mainhex();


function mainhex() {
  document.getElementById("content").innerHTML = "";

  function utf8ToHex(str) {
    return Array.from(str)
      .map((c) =>
        c.charCodeAt(0) < 128
          ? c.charCodeAt(0).toString(16)
          : encodeURIComponent(c).replace(/\%/g, "").toLowerCase()
      )
      .join("");
  }

  function splitStringBySegmentLength2(source, segmentLength) {
    if (!segmentLength || segmentLength < 1)
      throw Error("Segment length must be defined and greater than/equal to 1");
    const target = [];
    for (
      const array = Array.from(source);
      array.length;
      target.push(array.splice(0, segmentLength).join(""))
    );
    return target;
  }

  let canvas, renderer;

  const scenes = [];

  init();
  animate();

  function init() {
    canvas = document.getElementById("c");

    const content = document.getElementById("content");
    const inputhex = [];
    const sourcehex = [];
    const hexPairs = [];

    for (let i = 0; i < 12; i++) {
      const scene = new THREE.Scene();

      // make a list item
      const element = document.createElement("div");
      element.className = "list-item";

      const sceneElement = document.createElement("div");
      element.appendChild(sceneElement);

      const descriptionElement = document.createElement("div");

      descriptionElement.innerText =
        wordlist[(wordlist.length * Math.random()) | 0] +
        " " +
        satlist[(satlist.length * Math.random()) | 0];

      inputhex.push(descriptionElement.innerHTML);
      // console.log(inputhex);
      sourcehex.push(utf8ToHex(inputhex[i]));
      //console.log(sourcehex);
      hexPairs.push(splitStringBySegmentLength2(sourcehex[i], 6));
      // console.log(hexPairs);

      descriptionElement.innerHTML += "<br><span class='base'>"+sourcehex[i]+"</span>";

      element.appendChild(descriptionElement);

      // the element that represents the area we want to render the scene
      scene.userData.element = sceneElement;
      content.appendChild(element);

      const camera = new THREE.PerspectiveCamera(
        50, //fov
        window.innerWidth / window.innerHeight,
        2,
        20 //far
      );

      var rot= Math.floor(Math.random() * 6);
      if (rot ==0){camera.position.x = Math.PI/4;}
      else if (rot ==1){camera.position.y = Math.PI/4;}
      else{camera.position.z = (Math.PI/2)+0.5;}

     // camera.position.x = 2.8;
     // camera.position.y = 2.8;
      //camera.position.z = 2.8;
      //camera.position.z = Math.PI / 2;

      scene.userData.camera = camera;

      const controls = new OrbitControls(
        scene.userData.camera,
        scene.userData.element
      );
      controls.target.set(0, 0, 0);

      controls.enableDamping = true;
      controls.minDistance = 2; //101orig
      controls.maxDistance = 6; //101orig
      controls.rotateSpeed = 1; //1
      controls.zoomSpeed = 0.1;

      controls.enablePan = false;
      controls.enableZoom = true;
      controls.update();
      scene.userData.controls = controls;

      // add one random mesh to each scene
      const geometry = new THREE.OctahedronGeometry(0.05, 0);
      const geometryb = new THREE.BoxGeometry(1, 1, 0.1);
      const geometryc = new THREE.OctahedronGeometry(0.75, 0);
      //geometries[(geometries.length * Math.random()) | 0];

      const gemBackMaterial = new THREE.MeshPhysicalMaterial({
        // map: envMap,
        map: null,
        color:
          "#" +
          hexPairs[i][Math.floor(Math.random() * (hexPairs[i].length - 1))],
        // color: 0x000ff,
        metalness: 1,
        roughness: 0.1,
        opacity: 0.5,
        side: THREE.BackSide,
        transparent: true,
        envMapIntensity: 0.5, //5
        premultipliedAlpha: true,
        reflectivity: 1,

        // TODO: Add custom blend mode that modulates background color by this materials color.
      });

      const gemFrontMaterial = new THREE.MeshPhysicalMaterial({
        map: null,
        color: "#" + hexPairs[i][0],
        metalness: 0,
        roughness: 0.2,
        opacity: 0.25,
        side: THREE.FrontSide,
        transparent: true,
        envMapIntensity: 1, //10
        premultipliedAlpha: true,
        // transmission: 1,
        // thickness: 0.5,
      });

      const secondgeometry = geometry.clone();
      const secondgeometryb = geometryb.clone();

      scene.add(new THREE.Mesh(geometry, gemBackMaterial));
      scene.add(new THREE.Mesh(secondgeometry, gemFrontMaterial));
      scene.add(new THREE.Mesh(geometryb, gemBackMaterial));
      scene.add(new THREE.Mesh(secondgeometryb, gemFrontMaterial));

      const wireframe = new THREE.WireframeGeometry(geometryc);

      const wireMaterial = new THREE.LineBasicMaterial({
        color: "#" + hexPairs[i][0],
        linewidth: 1,
      });

      const rwire = new THREE.LineSegments(wireframe, wireMaterial);
      rwire.rotation.z = Math.PI / 4;
      scene.add(rwire);

      new RGBELoader().load(
        "./data/drachenfels_cellar_1k.hdr",
        function (texture) {
          texture.mapping = THREE.EquirectangularReflectionMapping;

          gemFrontMaterial.envMap = gemBackMaterial.envMap = texture;
          gemFrontMaterial.needsUpdate = gemBackMaterial.needsUpdate = true;
        }
      );

      scene.add(new THREE.AmbientLight(0x222222));

      const pointLight1 = new THREE.PointLight(0xff0000);
      pointLight1.position.set(150, 10, 0);
      scene.add(pointLight1);

      const pointLight2 = new THREE.PointLight(0x00ff00);
      pointLight2.position.set(-150, 10, 0);
      scene.add(pointLight2);

      const pointLight1b = new THREE.PointLight(0xff0000);
      pointLight1b.position.set(10, 150, 0);
      scene.add(pointLight1b);

      const pointLight2b = new THREE.PointLight(0x00ff00);
      pointLight2b.position.set(-10, -150, 0);
      scene.add(pointLight2b);

      const pointLight3 = new THREE.PointLight("#" + hexPairs[i][1], 0.5);
      pointLight3.position.set(0, 0, -300);
      scene.add(pointLight3);

      const pointLight4 = new THREE.PointLight("#" + hexPairs[i][0], 0.5);
      pointLight4.position.set(0, 0, 300);
      scene.add(pointLight4);

      let c = 0;
      let d = hexPairs[i].length - 1;
      setInterval(function () {
        let r = hexPairs[i][Math.floor(Math.random() * d)];
        if (c < d) {
          wireMaterial.color.set("#" + hexPairs[i][c]);
          gemFrontMaterial.color.set("#" + hexPairs[i][c]);
          gemBackMaterial.color.set("#" + r);
          pointLight4.color.set("#" + hexPairs[i][c]);
          pointLight3.color.set("#" + r);
          //console.log(Math.floor(Math.random()*d));
          c++;
        } else {
          c = 0;
        }
      }, 200);

      //console.log("#"+hexPairs[i][0]);
      scene.background = null;
      scenes.push(scene);
    }

    renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      antialias: true,
      alpha: true,
    });

    renderer.setClearColor(0x000000, 0);

    renderer.outputColorSpace = THREE.SRGBColorSpace;

    //scene.background = null;
    renderer.setPixelRatio(window.devicePixelRatio);
  }

  function updateSize() {
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;

    if (canvas.width !== width || canvas.height !== height) {
      renderer.setSize(width, height, false);
    }
  }

  function animate() {
    render();
    requestAnimationFrame(animate);
  }

  function render() {
    updateSize();

    canvas.style.transform = `translateY(${window.scrollY}px)`;

    renderer.setClearColor(0x000000, 0);
    renderer.setScissorTest(false);
    renderer.clear();

    renderer.setClearColor(0x000000, 0);
    renderer.setScissorTest(true);

    scenes.forEach(function (scene) {
      scene.children[0].rotation.z += 0.005;
      scene.children[1].rotation.z += 0.005;
      scene.children[2].rotation.z += 0.005;
      scene.children[3].rotation.z += 0.005;
      scene.children[4].rotation.z += 0.005;

      // get the element that is a place holder for where we want to
      // draw the scene
      const element = scene.userData.element;

      // get its position relative to the page's viewport
      const rect = element.getBoundingClientRect();

      // check if it's offscreen. If so skip it
      if (
        rect.bottom < 0 ||
        rect.top > renderer.domElement.clientHeight ||
        rect.right < 0 ||
        rect.left > renderer.domElement.clientWidth
      ) {
        return; // it's off screen
      }

      // set the viewport
      const width = rect.right - rect.left;
      const height = rect.bottom - rect.top;
      const left = rect.left;
      const bottom = renderer.domElement.clientHeight - rect.bottom ;
      let ww = window.innerWidth;
      let hh = window.innerHeight;
      if(hh<=ww){     
      const camera = scene.userData.camera;
      camera.fov = 50;
      camera.updateProjectionMatrix(); 
      renderer.setViewport(left, bottom+((height/33)*4), width, height-((height/33)*8));
      renderer.setScissor(left, bottom+((height/33)*4), width, height-((height/33)*8));
      }
      else{
        //set fov
      const camera = scene.userData.camera;
      camera.fov = 60;
      camera.updateProjectionMatrix();
      renderer.setViewport(left+((width/33)*4), bottom, width-((width/33)*8), height);
      renderer.setScissor(left+((width/33)*4), bottom, width-((width/33)*8), height);
      }
      const camera = scene.userData.camera;

      renderer.render(scene, camera);
    });
  }
}
